export default "__VITE_PUBLIC_ASSET__11d142c2__"